import { useState, useEffect } from 'react';
import CountUp from 'react-countup';

const ConsolidatedCounters = (props) => {

    const [counterOptions, setCounterOptions] = useState([
        { label: "Total", value: "Total" },
        { label: "Mobile No Not Registered", value: "Mobile No Not Registered" },
        { label: "Consent Pending", value: "Consent Pending" },
        { label: "Consent Declined", value: "Consent Declined" },
        { label: "Consent Approved", value: "Consent Approved" },
    ]);

    const [selectedCounter, setSelectedCounter] = useState('Total');

    const handleCounterClick = (counter) => {
        props?.setCounter(counter);
        setSelectedCounter(counter);
    };

    useEffect(() => {
        setSelectedCounter('Total');
    }, [props.tabName]);

    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-sm-12 beffect">
                <div className="card">
                    <div className="card-body" id="counterCardBody">
                        <div className="crm-numbers pb-0">
                            <div className="row">
                            <div className="col cirlce-d cursorPointer" onClick={() => handleCounterClick(counterOptions[0].value)} style={{position:"relative"}}>
                                    <span className={`f13 ${selectedCounter === counterOptions[0].value ? 'fbold blackColor' : ''}`}><i  className="icofont icofont-ui-browser f24 greenfont"></i><br /> Total</span>
                                    <h4 className="txt-secondary f40"><span className="counter greenfont"><CountUp end={props.data.totalData ? props.data.totalData : 0} /></span></h4>
                                    {selectedCounter === counterOptions[0].value && <span className='anchor-down'></span>}
                                </div>
                                <div className="col cirlce-d cursorPointer" onClick={() => handleCounterClick(counterOptions[1].value)} style={{position:"relative"}}>
                                    <span className={`f13 ${selectedCounter === counterOptions[1].value ? 'fbold blackColor' : ''}`}><i style={{color:"#dc3545"}} className="icofont icofont-close-circled f24 txt-secondary cstm-und"></i><br /> Mobile No Not Registered</span>
                                    <h4 className="txt-secondary f40"><span className="counter"><CountUp style={{color:"#dc3545"}} end={props.data.consentNotRegistered ? props.data.consentNotRegistered : 0} /></span></h4>
                                    {selectedCounter === counterOptions[1].value && <span className='anchor-down'></span>}
                                </div>
                                    <div className="col cursorPointer" onClick={() => handleCounterClick(counterOptions[2].value)} style={{position:"relative"}}>
                                        <span className={`f13 ${selectedCounter === counterOptions[2].value ? 'fbold blackColor' : ''}`}><i className="icofont icofont-hour-glass f24 txt-secondary cst-pending"></i><br /> Consent Pending</span>
                                        <h4 className="txt-secondary f40"><span className="counter"><CountUp  style={{color:"#ffc107"}} end={props.data.consentPending ? props.data.consentPending : 0} /></span></h4>
                                        {selectedCounter === counterOptions[2].value && <span className='anchor-down'></span>}
                                    </div>
                                    <div className="col cursorPointer" onClick={() => handleCounterClick(counterOptions[3].value)} style={{position:"relative"}}>
                                        <span className={`f13 ${selectedCounter === counterOptions[3].value ? 'fbold blackColor' : ''}`}><i className="icofont icofont-close-line f24 txt-secondary cst-dsbled"></i><br /> Consent Declined</span>
                                        <h4 className="txt-secondary f40"><span className="counter"><CountUp  style={{color:"#adb5bd"}} end={props.data.consentDeclined ? props.data.consentDeclined : 0} /></span></h4>
                                        {selectedCounter === counterOptions[3].value && <span className='anchor-down'></span>}
                                    </div>
                                    <div className="col cursorPointer" onClick={() => handleCounterClick(counterOptions[4].value)} style={{position:"relative"}}>
                                        <span className={`f13 ${selectedCounter === counterOptions[4].value ? 'fbold blackColor' : ''}`}><i className="icofont icofont-check-circled f24 greenfont"></i><br /> Consent Approved</span>
                                        <h4 className="txt-info f40"><span className="counter greenfont"><CountUp end={props.data.consentApproved ? props.data.consentApproved : 0} /></span></h4>                                            
                                        {selectedCounter === counterOptions[4].value && <span className='anchor-down'></span>}
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default ConsolidatedCounters;
